export default [
  {
    header: 'Security',
    action: 'manage',
    resource: 'all',
  },
  {
    title: 'Login Sessions',
    icon: 'ShieldIcon',
    route: 'login-sessions',
    action: 'manage',
    resource: 'all',
  },
  {
    title: 'Security Settings',
    icon: 'SettingsIcon',
    route: 'security-settings',
    action: 'manage',
    resource: 'all',
  },
  {
    title: 'Audit Log',
    icon: 'FileTextIcon',
    route: 'audit-logs',
    resource: 'system',
    action: ['read', 'update'],
  },
]
